import { MessageCircle, Phone, PenLine } from "lucide-react";
import { wa, WA_MESSAGES, PHONE_TEL, scrollToId } from "@/lib/site";

export default function FloatingCTA() {
  return (
    <>
      <a
        data-testid="floating-whatsapp-button"
        href={wa(WA_MESSAGES.default)}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with MAHIRA on WhatsApp"
        className="wa-pulse fixed bottom-24 right-5 z-50 inline-flex items-center gap-3 rounded-full bg-[#25D366] py-3.5 pl-4 pr-5 text-white shadow-[0_18px_45px_-12px_rgba(37,211,102,0.6)] transition-transform duration-300 hover:-translate-y-1 md:bottom-8 md:right-8"
      >
        <MessageCircle className="h-6 w-6" />
        <span className="hidden text-[12px] font-semibold uppercase tracking-[0.14em] md:inline">
          Chat With MAHIRA
        </span>
      </a>

      <div
        data-testid="sticky-mobile-cta"
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-forest/10 bg-ivory/90 backdrop-blur-xl md:hidden"
      >
        <a
          data-testid="sticky-call-button"
          href={PHONE_TEL}
          className="flex flex-col items-center gap-1 py-3 text-forest"
        >
          <Phone className="h-5 w-5" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.16em]">
            Call
          </span>
        </a>
        <a
          data-testid="sticky-whatsapp-button"
          href={wa(WA_MESSAGES.order())}
          target="_blank"
          rel="noreferrer"
          className="flex flex-col items-center gap-1 bg-forest py-3 text-ivory"
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.16em]">
            Order
          </span>
        </a>
        <button
          data-testid="sticky-enquire-button"
          onClick={() => scrollToId("join")}
          className="flex flex-col items-center gap-1 py-3 text-forest"
        >
          <PenLine className="h-5 w-5" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.16em]">
            Enquire
          </span>
        </button>
      </div>
    </>
  );
}
